import styled from "@emotion/styled";

export const TableContainer = styled.div`
  display: flex;
  min-width: 980px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const IndexContainer = styled.div`
  display: flex;
  min-width: 738px;
  padding: 12px 24px;
  align-items: center;
  align-self: stretch;
  gap: 32px;

  border-radius: 12px;
  background: var(--component-color-fill-alternative);
`;

export const EmptyLow = styled.div`
  display: flex;
  padding: 12px 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const RowContainer = styled.div`
  display: flex;
  min-width: 738px;
  padding: 8px 24px;
  align-items: center;
  align-self: stretch;
  gap: 32px;

  border-bottom: 1px solid var(--alias-color-line-normal);

  .user {
    display: flex;
    min-width: 160px;
    max-width: 200px;
    align-items: center;
    gap: 20px;
    flex: 1 0 0;
  }

  .email {
    display: flex;
    flex: 1 0 0;
  }

  .empty-picture {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--component-color-fill-normal);
  }

  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }
`;
